'use strict';

module.exports = {
    GALLERY_SETUP_STORE: 'gallery:setup-store',
    GALLERY_RESET_STORE: 'gallery:reset-store',
    GALLERY_PHOTOS_LOAD_START: 'gallery:photos-load-start',
    GALLERY_PHOTOS_LOAD_DONE: 'gallery:photos-load-done',
    GALLERY_PHOTOS_LOAD_FAILED: 'gallery:photos-load-failed',
    GALLERY_SET_PHOTO: 'gallery:set-photo',
    GALLERY_SWITCH_PHOTO: 'gallery:switch-photo',
    GALLERY_UPDATE_COPY: 'gallery:update-copy',
    GALLERY_ADD_SIMILAR_ITEMS_TEMPLATE: 'gallery:similar-items-add-template',
    GALLERY_ADD_MORE_PROJECTS_TEMPLATE: 'gallery:more-projects-add-template',
    GALLERY_MOBILE_SHOW_SOCIAL: 'gallery:show-social-mobile',
    GALLERY_MOBILE_SHOW_DETAILS: 'gallery:show-details-mobile',

    PHOTO_UI_UPDATE_DIMENSIONS: 'PHOTO_UI_UPDATE_DIMENSIONS',
    PHOTO_UI_SHOW_ITEM_TAGS: 'PHOTO_UI_SHOW_ITEM_TAGS',
    PHOTO_UI_HIDE_ITEM_TAGS: 'PHOTO_UI_HIDE_ITEM_TAGS',
    PHOTO_UI_SET_ITEM_TAG: 'PHOTO_UI_SET_ITEM_TAG',
    PHOTO_UI_UNSET_ITEM_TAG: 'PHOTO_UI_UNSET_ITEM_TAG',
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/actions/galleryActionConstants.js
// module id = 312
// module chunks = 4 20 22 24